export default "__VITE_ASSET__e0b3d59b__"